export const FETCH_CHANNELS_FLOORSPACE = 'ChannelsFloorspaceModal/FETCH_CHANNELS_FLOORSPACE'
export const FETCH_CHANNELS_FLOORSPACE_ERROR = 'ChannelsFloorspaceModal/FETCH_CHANNELS_FLOORSPACE_ERROR'
export const FETCH_CHANNELS_FLOORSPACE_SUCCESS = 'ChannelsFloorspaceModal/FETCH_CHANNELS_FLOORSPACE_SUCCESS'

export const SET_SORT = 'ChannelsFloorspaceModal/SET_SORT'

export const SORT_COLUMNS = {
  TITLE: 'channel',
  FLOOR_SPACE_PER_STORE_CURRENT: 'floorSpacePerStoreCurrent',
  REVENUE_PER_M2_CURRENT: 'revenuePerM2Current',
  STORES_CURRENT: 'storesCurrent',
}
